interface useFormProps {
  errorHandler?: (set: (property: string, error: string) => void) => void;
  isLoadingInitials?: boolean;
  isLoadingActions?: boolean;
}

const useForm = ({ errorHandler, isLoadingInitials, isLoadingActions }: useFormProps) => {
  const errors: { property: string; error: string }[] = [];
  const set = (property, error) => {
    errors.push({ property, error });
  };
  if (errorHandler) {
    errorHandler(set);
  }

  return {
    errors,
    isValid: errors.length === 0,
    isLoadingInitials,
    isLoadingActions,
  };
};

export default useForm;
